import { useUserStore } from '@/stores/user.js'

// We add 'to' here to see where the user is navigating
export default async function venue({ next, to }) {
  try {
    const userStore = useUserStore()
    const { currentVenue } = userStore

    if (!Object.keys(currentVenue).length && userStore.user?.email_verified === 1) {
      return next({ name: 'create-organization' })
    }

    const isFullyVerified =
      !currentVenue.should_verify &&
      currentVenue.vip_verification_status !== 'UNVERIFIED_WITH_ERROR'

    if (to.name.includes('verify-account')) {
      if (isFullyVerified) {
        return next({ name: 'dashboard' })
      }
    }

    return next()
  } catch (e) {
    return next({ name: 'login' })
  }
}
